import { createApp } from 'vue'
import App from './App.vue'
import '@/assets/css/reset.css'
import '@/assets/css/theme/index.scss'
import ElementPlus from 'element-plus';
// import 'element-plus/lib/theme-chalk/index.css';
// import 'element-plus/dist/index.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import '@wangeditor/editor/dist/css/style.css'
import 'vue-cropper/dist/index.css'
import '@/assets/css/index.css'
import "@/assets/iconfont/iconfont.css";
import '@/assets/css/tailwind.css'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import store from './store'
import router from './router'
import tips from '@/common/tips'
import axios from '@/common/axios'
import tools from '@/common/tool'
import urls from '@/common/urls'
import config from '@/common/config'
import uploads from '@/common/uploads'
import Video from 'video.js'// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import 'video.js/dist/video-js.css'
// import vConsole from "@/common/vconsole"
// import 'default-passive-events'
let Vue = createApp(App)
Vue.use(ElementPlus, { locale: zhCn })
Vue.use(Viewer)
Vue.use(router)
Vue.use(store)
Vue.config.globalProperties.$video = Video
Vue.config.globalProperties.$tips = tips
Vue.config.globalProperties.$axios = axios
Vue.config.globalProperties.$config = config
Vue.config.globalProperties.$urls = urls
Vue.config.globalProperties.$tools = tools
Vue.config.globalProperties.$uploads = uploads
Vue.mount('#app')


//解决IOS下拉框搜索没有弹出键盘的问题,下拉搜索框务必加上el-custom-filterable样式
Vue.mixin({
    mounted() {
        if (typeof this.$el.className === 'string') {
            if (this.$el.className.split(' ').indexOf('el-select') !== -1 && this.$el.className.split(' ').indexOf('el-custom-filterable') !== -1) {
                this.$el.children[0].children[0].children[0].removeAttribute('readOnly')
                this.$el.children[0].children[0].children[0].onblur = function () {
                    let _this = this
                    setTimeout(() => {
                        _this.removeAttribute('readOnly')
                    }, 200)
                }
            }
        }
    }
})



